import { Component, OnInit, TemplateRef } from "@angular/core";
import { ListService } from "../../../../auth/service/list.service";
import { ICustomerType } from "../../customer.interface";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { UtilsService } from "../../../../auth/service/utils.service";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { AuthenticationService } from "../../../../auth/service";
import { Router } from "@angular/router";

@Component({
  selector: "app-customer-type-list",
  templateUrl: "./customer-type-list.component.html",
})
export class CustomerTypeListComponent implements OnInit {
  private customerTypeList: ICustomerType[] = [];
  public filteredTypesList: ICustomerType[] = [];
  public contentHeader: IContentHeader;
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  private list_type: string = "customer_type";
  public typeForm: Partial<ICustomerType> = {
    id: null,
    name: null,
    other: {
      code: null,
    },
  };
  public showModalError: boolean = false;

  constructor(
    public listService: ListService,
    private _routerService: Router,
    public _authenticationService: AuthenticationService,
    public _utilService: UtilsService,
    private _modalService: NgbModal,
  ) {
    this.contentHeader = {
      headerTitle: "MENU.CUSTOMERS_TYPE_PLURAL",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: "MENU.CUSTOMERS",
            isLink: false,
          },
          {
            name: "MENU.CUSTOMERS_TYPE_PLURAL",
            isLink: false,
          },
        ],
      },
    };
  }

  ngOnInit() {
    this.load();
  }

  load() {
    this.listService.getList(this.list_type).then((result: ICustomerType[]) => {
      this.customerTypeList = result;
      this.filterTypes();
    });
  }

  filterTypes() {
    const key: string = this.searchKeyword.trim().toLowerCase();
    let filterItem: ICustomerType[] = this.customerTypeList;
    if (key.length > 0) {
      filterItem = filterItem.filter((item: ICustomerType) => item.name.toLowerCase().trim().includes(key));
    }
    this.filteredTypesList = filterItem;
  }

  modalOpen(modal: TemplateRef<any>, selectedType: ICustomerType | undefined = undefined) {
    this._modalService.open(modal, {
      size: "md",
      centered: true,
    });
    this.typeForm = {
      id: null,
      name: "",
      other: {
        code: "",
      },
    };
    if (selectedType) {
      this.typeForm = selectedType;
    }
    this.showModalError = false;
  }

  isError(): boolean {
    this.showModalError = this.typeForm.name === null || this.typeForm.name.length < 1 || this.typeForm.other.code === null || this.typeForm.other.code.length < 1;
    return this.showModalError;
  }

  async addType() {
    if (!this._authenticationService.hasCapability("create_customer_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    delete this.typeForm.id;

    this._utilService.showLoading();
    await this.listService
      .create(this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_ADD_CUSTOMER_TYPE");
        this.typeForm = {
          id: null,
          name: "",
          other: {
            code: "",
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_ADD_CUSTOMER_TYPE");
      });
  }

  async editType() {
    if (!this._authenticationService.hasCapability("edit_customer_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    if (this.isError()) {
      return false;
    }

    const idType: number = this.typeForm.id;
    delete this.typeForm.id;
    delete this.typeForm.type;

    this._utilService.showLoading();
    await this.listService.update(idType, this.typeForm, this.list_type)
      .then(() => {
        this._modalService.dismissAll();
        this.load();
        this._utilService.hideLoading();
        this._utilService.showToastrSuccess("SUCCESS_EDIT_CUSTOMER_TYPE");
        this.typeForm = {
          id: null,
          name: "",
          other: {
            code: "",
          },
        };
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showToastrError("ERROR_EDIT_CUSTOMER_TYPE");
      });

  }

  async deleteCustomerType(selectedType: ICustomerType) {
    if (!this._authenticationService.hasCapability("delete_customer_type")) {
      await this._routerService.navigateByUrl("/dashboard/main");
      return false;
    }

    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selectedType.name;

    await this._utilService
      .showSWALDeleteConfirmation({ text: deleteText })
      .then(async (result) => {
        if (result.value) {
          this._utilService.showLoading();
          await this.listService.delete(selectedType.id, this.list_type).then(() =>
            this._utilService.showPopupItemDeleted().then(async () => {
              this.load();
              await this._utilService.showToastrSuccess("SUCCESS_DELETE_CUSTOMER_TYPE");
            }),
          );
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      })
      .catch(() => this._utilService.showToastrError("ERROR_DELETE_CUSTOMER_TYPE"));
  }
}
